import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Language, ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-language-modal',
  templateUrl: './language-modal.component.html',
  styleUrls: ['./language-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalModule, TranslatePipe, TranslateDirective, ButtonV2Module],
})
export class LanguageModalComponent {
  private readonly modalRef = inject<ModalRef<void>>(ModalRef);

  public selectedLanguage: Language;

  public get buttonDisabled(): boolean {
    return this.selectedLanguage === localStorage.getItem('language');
  }

  constructor() {
    this.selectedLanguage = localStorage.getItem('language') as Language;
  }

  public apply(): void {
    const event: Partial<StorageEvent> = {
      newValue: this.selectedLanguage,
      key: 'language',
    };

    localStorage.setItem('language', this.selectedLanguage);
    dispatchEvent(new StorageEvent('storage', event));
    this.modalRef.close();
  }

  public close(): void {
    this.modalRef.close();
  }

  public changeLanguage(language: Language): void {
    this.selectedLanguage = language;
  }
}
